import { useQuery } from 'react-query';
import useFetchObjects from '../../../api/useFetchObjects';
import { useAuth } from '../../../context/AuthContext';

export const useDashboardData = (token, period='daily') => {
  // Document statistics
  const docStatsQuery = useFetchObjects(`documents/stats?period=${period}`, {}, token);
  const { data: documentStats, isLoading: docStatsLoading, isError: docStatsError } = docStatsQuery;
  const docTypesQuery = useFetchObjects(`documents/types?period=${period}`, {}, token);
  const { data: documentTypes, isLoading: docTypesLoading, isError: docTypesError } = docTypesQuery;
  const docPrioritiesQuery = useFetchObjects(`documents/priorities?period=${period}`, {}, token);
  const { data: documentPriorities, isLoading: docPrioritiesLoading, isError: docPrioritiesError } = docPrioritiesQuery;
  const recentDocsQuery = useFetchObjects(`documents/recent?period=${period}`, {}, token);
  const { data: recentDocuments, isLoading: recentDocsLoading, isError: recentDocsError } = recentDocsQuery;
  
  // Task statistics
  const taskStatsQuery = useFetchObjects(`tasks/stats?period=${period}`, {}, token);
  const { data: taskStats, isLoading: taskStatsLoading, isError: taskStatsError } = taskStatsQuery;
  const overdueTasksQuery = useFetchObjects(`tasks/overdue?period=${period}`, {}, token);
  const { data: overdueTasks, isLoading: overdueTasksLoading, isError: overdueTasksError } = overdueTasksQuery;
  const taskStatusQuery = useFetchObjects(`tasks/status-stats?period=${period}`, {}, token);
  const { data: taskStatsByStatus, isLoading: taskStatusLoading, isError: taskStatusError } = taskStatusQuery;
  const userWorkloadQuery = useFetchObjects(`tasks/workload?period=${period}`, {}, token);
  const { data: userWorkload, isLoading: userWorkloadLoading, isError: userWorkloadError } = userWorkloadQuery;
  
  // Document source analysis
  const docSourcesQuery = useFetchObjects(`documents/sources?period=${period}`, {}, token);
  const { data: documentSources, isLoading: docSourcesLoading, isError: docSourcesError } = docSourcesQuery;
  const confidentialQuery = useFetchObjects(`documents/confidential?period=${period}`, {}, token);
  const { data: confidentialStats, isLoading: confidentialLoading, isError: confidentialError } = confidentialQuery;
  
  // New assignment stats
  const assignedByMeStatsQ = useFetchObjects(`tasks/assigned-by-me/stats?period=${period}`, {}, token);
  const { data: assignedByMeRaw } = assignedByMeStatsQ;
  const assignedToMeStatsQ = useFetchObjects(`tasks/assigned-to-me/stats?period=${period}`, {}, token);
  const { data: myAssignmentsRaw } = assignedToMeStatsQ;
  const recentAssignedByMeQ = useFetchObjects(`tasks/assigned-by-me/recent?period=${period}`, {}, token);
  const { data: recentAssignedByMe } = recentAssignedByMeQ;
  const recentAssignedToMeQ = useFetchObjects(`tasks/assigned-to-me/recent?period=${period}`, {}, token);
  const { data: recentAssignedToMe } = recentAssignedToMeQ;

  // --- assignment status stats ---
  const assignedByMeStats = assignedByMeRaw || {};
  const myAssignmentsStats = myAssignmentsRaw || {};

  // Debug logging
  console.log('useDashboardData - assignedByMeStats:', assignedByMeStats);
  console.log('useDashboardData - myAssignmentsStats:', myAssignmentsStats);
  console.log('useDashboardData - recentAssignedByMe:', recentAssignedByMe);
  console.log('useDashboardData - recentAssignedToMe:', recentAssignedToMe);

  // Aggregate loading & error states
  const isLoading = [docStatsLoading, docTypesLoading, docPrioritiesLoading, recentDocsLoading,
    taskStatsLoading, overdueTasksLoading, taskStatusLoading, userWorkloadLoading,
    docSourcesLoading, confidentialLoading, assignedByMeStatsQ.isLoading, assignedToMeStatsQ.isLoading, recentAssignedByMeQ.isLoading, recentAssignedToMeQ.isLoading].some(Boolean);
  const isError = [docStatsError, docTypesError, docPrioritiesError, recentDocsError,
    taskStatsError, overdueTasksError, taskStatusError, userWorkloadError,
    docSourcesError, confidentialError, assignedByMeStatsQ.isError, assignedToMeStatsQ.isError, recentAssignedByMeQ.isError, recentAssignedToMeQ.isError].some(Boolean);
  return {
    documentStats,
    documentTypes,
    documentPriorities,
    taskStats,
    overdueTasks,
    taskStatsByStatus,
    userWorkload,
    documentSources,
    confidentialStats,
    recentDocuments,
    isLoading,
    isError,
    assignedByMeStats,
    myAssignmentsStats,
    recentAssignedByMe,
    recentAssignedToMe
  };
};
